// extracted by mini-css-extract-plugin
module.exports = {"container":"LabelValuePair_container__2RT8i","value":"LabelValuePair_value__dXZnx","large":"LabelValuePair_large__2rJDC","horizontal":"LabelValuePair_horizontal__1IP-e"};